// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_slU","cls2":"common-cls2_W_u common-cls1_slU","wide":"common-wide_Ibf","widest":"common-widest_l7y","right":"common-right_wY2","docked":"common-docked_qz-"};